/**
 * Kullanıcı veya backend kaynaklı bir değeri HTML string içine eklemeden önce encode eder.
 * Swal `html`/`title`, ag-grid string cellRenderer gibi innerHTML'e yazılan yerlerde
 * birleştirilen her dinamik değer bu fonksiyondan geçirilmelidir (Stored XSS önlemi).
 *
 * Bağımlılığı olmayan ayrı bir dosyada tutulur; AppHelper ↔ AlertService arasında
 * döngüsel import oluşmaması için.
 */
export function escapeHtml(value: any): string {
  if ((value === null) || (value === undefined)) {
    return '';
  }

  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
